import * as React from 'react';
import {useForm, Path, UseFormRegister, SubmitHandler} from 'react-hook-form';
import BlogPostSelectSeasonGeneric from './BlogPostSelectSeasonGeneric';
import BlogPostSelectCompGeneric from './BlogPostSelectCompGeneric';
import BlogPostSelectClubGeneric from './BlogPostSelectClubGeneric';
import {
  filterDefaultCompBySeason,
  filterDefaultRoundBySeasonAndComp,
} from '@nls-2022/nls-bll';
import {
  generateCompBlogPost,
  generateCompResultBlogPost,
  FAComps,
} from '@nls-2022/nls-bll';
export type BlogPostNewFACompResultSelectFormPropsType = {
  setGeneratedBlogPost: any;
  setInitInputForm: any;
  clubSeasonCompData: any;
};
export interface ICompSelectFormValues {
  Season: string;
  Comp: string;
  Club: string;
  LosingClub: string;
}

export type InputProps = {
  label: Path<ICompSelectFormValues>;
  register: UseFormRegister<ICompSelectFormValues>;
  required: boolean;
};

const BlogPostNewFACompResultSelectForm = ({
  setGeneratedBlogPost,
  setInitInputForm,
  clubSeasonCompData,
}: BlogPostNewFACompResultSelectFormPropsType) => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: {errors},
  } = useForm<ICompSelectFormValues>();
  const onSubmit: SubmitHandler<ICompSelectFormValues> = data => {
    //console.log(data);
    let losingClub = clubs.find(u => u !== data.Club);
    let generatedCompResultBlogPost = generateCompResultBlogPost(
      data.Season,
      data.Comp,
      data.Club,
      losingClub!,
    );
    setGeneratedBlogPost(generatedCompResultBlogPost);
    setInitInputForm(true);
  };
  const [clubs, setClubs] = React.useState<Array<string>>([]); //: Array<string> = [];
  let watchSelectedSeason = watch('Season', '');
  let watchSelectedComp = watch('Comp', '');
  let watchSelectedClub = watch('Club', '');

  React.useEffect(() => {
    setValue('Comp', '');
    setValue('Club', '');
    setValue('LosingClub', '');
    setClubs([]);
  }, [watchSelectedSeason]);

  React.useEffect(() => {
    setValue('Club', '');
    if (
      watchSelectedSeason !== null &&
      watchSelectedSeason !== '' &&
      watchSelectedSeason !== undefined &&
      watchSelectedComp !== undefined &&
      watchSelectedComp !== null &&
      watchSelectedComp !== ''
    ) {
      let compDataforSeason = clubSeasonCompData.find((u: {season: any}) => {
        return u.season === watchSelectedSeason;
      });
      //console.dir(compDataforSeason!.compDetailsList!);
      //console.log(compDataforSeason);
      //console.log(watchSelectedComp);
      //console.log(watchSelectedClub);
      let faComp = FAComps.find((u: {name: string}) => {
        return u.name === watchSelectedComp;
      });
      let filteredClubs: Array<string> =
        compDataforSeason!.compDetailsList?.find(
          (u: {comp: any}) => u.comp === faComp?.comp,
        )?.clubs!;
      setClubs(filteredClubs);
    }
  }, [watchSelectedComp]);

  let disableGenerate: boolean =
    watchSelectedSeason === null ||
    watchSelectedSeason === '' ||
    watchSelectedComp === null ||
    watchSelectedComp === '' ||
    watchSelectedClub === null ||
    watchSelectedClub === '';

  return (
    <section id="selectfacomp">
      <h3>Select Data...</h3>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 flex flex-col md:flex-row md:items-center md:h-32"
      >
        {/* register your input into the hook by invoking the "register" function */}
        <div className="mb-4 mr-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">
            Season
          </label>
          <BlogPostSelectSeasonGeneric
            register={register}
            setValue={setValue}
            selectedSeason={watchSelectedSeason}
          />
        </div>

        <BlogPostSelectCompGeneric
          register={register}
          setValue={setValue}
          selectedSeason={watchSelectedSeason}
          selectedComp={watchSelectedComp}
          compBySeason={clubSeasonCompData}
        />
        <BlogPostSelectClubGeneric
          register={register}
          setValue={setValue}
          selectedSeason={watchSelectedSeason}
          clubs={clubs}
        />

        {/* include validation with required or other standard HTML validation rules */}

        <button
          className={`h-10 bg-green-500 border-green-500  text-sm border-4 text-white py-1 px-2 rounded uppercase ${
            !disableGenerate ? 'hover:bg-green-700 hover:border-green-700' : ''
          }`}
          type="submit"
          disabled={disableGenerate}
        >
          generate
        </button>
      </form>
    </section>
  );
};

export default BlogPostNewFACompResultSelectForm;
